export type DictionaryMode = "cantonese" | "mandarin";

// Build-time injection for client-side
declare const __DICTIONARY_MODE__: DictionaryMode | undefined;

// Determine mode: check build-time constant first, then env var, then default
function getDictionaryMode(): DictionaryMode {
  // Build-time constant (client-side)
  if (typeof __DICTIONARY_MODE__ !== "undefined") {
    return __DICTIONARY_MODE__;
  }
  // Runtime environment variable (server-side)
  if (typeof process !== "undefined" && process.env?.DICTIONARY_MODE) {
    return process.env.DICTIONARY_MODE as DictionaryMode;
  }
  // Default
  return "cantonese";
}

export const DICTIONARY_MODE = getDictionaryMode();

export const CONFIG = {
  cantonese: {
    appName: "Canto Dictionary",
    language: "Cantonese",
    pronunciationLabel: "Jyutping",
    pronunciationLabelLower: "jyutping",
    dictionaryFile: "/cccanto-webdist.txt",
    searchPlaceholder: "Enter Chinese, Jyutping, or English...",
    exampleSearches: ["love", "hello", "eat", "你好", "食飯", "jat1"],
  },
  mandarin: {
    appName: "Mando Dictionary",
    language: "Mandarin",
    pronunciationLabel: "Pinyin",
    pronunciationLabelLower: "pinyin",
    dictionaryFile: "/cedict_ts.u8",
    searchPlaceholder: "Enter Chinese, Pinyin, or English...",
    exampleSearches: ["love", "hello", "eat", "你好", "吃饭", "ni3 hao3"],
  },
} as const;

export const config = CONFIG[DICTIONARY_MODE];
